import { BoxSlotFormView } from "@/modules/boxSlot/components/boxSlotFormView"
import { useBoxSlotFormikCreate } from "@/modules/boxSlot/hooks/useBoxSlotFormik"

type BoxSlotFormCreateProps = {
  boxProgramId: string
  startDate: Date
  className?: string
} & React.ComponentProps<"div">

export function BoxSlotFormCreate({ boxProgramId, startDate, className, ...props }: BoxSlotFormCreateProps) {
  const formik = useBoxSlotFormikCreate(boxProgramId, startDate)

  return <BoxSlotFormView formik={formik} hideTitle={false} className={className} {...props} />
}
